import { render, staticRenderFns } from "./formgroupdatepicker.vue?vue&type=template&id=56c85eeb&"
import script from "./formgroupdatepicker.vue?vue&type=script&lang=js&"
export * from "./formgroupdatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports